export default "__VITE_ASSET__BimSveru__"